import {useMemo} from 'react';

import {TotalCountPerStatusObject} from '../types/RecruitingDashboardTypes';

import {useGetRequest} from '../../../../../hooks/useGetRequest';
import {getTotalMatchesCount} from '../../../../../lib/api/v1';
import {SerializeTo} from '../../../../../utils/serializer/serialize';

export const useTotalMatchesCount = (companyId: string) => {
  const fetchTotalMatchesCount = useMemo(() => {
    return () => getTotalMatchesCount(companyId);
  }, [companyId]);

  const {data, error} = useGetRequest(fetchTotalMatchesCount, SerializeTo.CamelCase<TotalCountPerStatusObject>);

  return {
    matchesTotalCount: data,
    error,
  };
};
